export function getSizeClass(size) {
    switch (size) {
        case "md":
            return "h-10 w-10"
        case "sm":
            return "h-8 w-8"
        default:
            return "h-10 w-10"
    }
}